import axios from "../lib/axios";

export const loginAdmin = async (data) => {
  try {
    const response = await axios.post("/admin/auth/login", data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to login");
  }
};

export const createAdmin = async (data) => {
  try {
    const response = await axios.post("/admin/auth/register", data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to login");
  }
};

export const getAllAdmins = async ({ limit = 20, lastId } = {}) => {
  try {
    const params = new URLSearchParams();

    if (limit) params.append("limit", limit.toString());
    if (lastId) params.append("lastId", lastId);

    const response = await axios.get(
      `/admin/auth/get-all?${params.toString()}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to fetch admins");
  }
};

export const updateOrDeleteAdmin = async (id, action, payload = {}) => {
  try {
    const response = await axios.put(`/admin/auth/update/${id}`, {
      action,
      ...payload,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update/delete admin"
    );
  }
};

export const adminDashboard = async () => {
  try {
    const response = await axios.get(`/admin/auth/dashboard/overview`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update/delete admin"
    );
  }
};
